export const setToken = (token) => {
    sessionStorage.setItem('token', token);
}

export const clearToken = () => {
    sessionStorage.removeItem('token');
}

export const getToken = () => {
    return sessionStorage.getItem('token');
}

export const isLoggedIn = () => {
    return getToken() !== null;
}

export const setUser = (user) => {
    console.log("Setting user: ");
    console.log(user);
    sessionStorage.setItem('user_id', user.id);
    sessionStorage.setItem('email', user.email);
    sessionStorage.setItem('firstname', user.firstname);
    sessionStorage.setItem('lastname', user.lastname);
    sessionStorage.setItem('role', user.role);
}

export const clearUser = () => {
    sessionStorage.removeItem('user_id');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('firstname');
    sessionStorage.removeItem('lastname');
    sessionStorage.removeItem('role');
    sessionStorage.clear();
}

export const getUser = () => {
    return {
        id: sessionStorage.getItem('user_id'),
        email: sessionStorage.getItem('email'),
        firstName: sessionStorage.getItem('firstname'),
        lastName: sessionStorage.getItem('lastname'),
        role: sessionStorage.getItem('role')
    }
}

export const getUserId = () => {
    return sessionStorage.getItem('user_id');
}

export const addToCart = (course) => {
    let cart = getCart();
    var existing = cart.find(c => c.id === course.id);
    if (existing) {
        existing.quantity += 1;
    } else {
        course.quantity = 1;
        cart.push(course);
    }
    sessionStorage.setItem('cart', JSON.stringify(cart));
}

export const updateCartQuantity = (id, quantity) => {
    let cart = getCart();
    var existing = cart.find(c => c.id === id);
    if (existing) {
        existing.quantity = quantity;
    }
    sessionStorage.setItem('cart', JSON.stringify(cart));
}

export const removeFromCart = (id) => {
    let cart = getCart();
    cart = cart.filter(c => c.id !== id);
    sessionStorage.setItem('cart', JSON.stringify(cart));
}

export const getCart = () => {
    let cart = sessionStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
}

export const clearCart = () => {
    sessionStorage.removeItem('cart');
}

export const getCartTotal = () => {
    let cart = getCart();
    let total = 0;
    cart.forEach(c => total += (c.price * c.quantity));
    return total;
}

export const getCartCount = () => {
    let cart = getCart();
    return cart.length;
}

export const getCartItems = () => {
    let cart = getCart();
    return cart;
}

export const getCartItemsIds = () => {
    let cart = getCart();
    let ids = [];
    cart.forEach(c => ids.push(c.id));
    return ids;
}

export const getCartItemsNames = () => {
    let cart = getCart();
    let names = [];
    cart.forEach(c => names.push(c.name));
    return names;
}
